/**
 * 日割り見積もり（フロント用）
 * サーバー正本: shared/billing/prorationEstimate.cjs
 */
import {
  cutoffMsForJstMonthEnd,
  lastUsageDayMsFromCutoff,
} from './jstDateHelper.js';

const JST = 'Asia/Tokyo';

export function getDaysInJstMonth(refMs) {
  const parts = new Intl.DateTimeFormat('ja-JP', {
    timeZone: JST,
    year: 'numeric',
    month: 'numeric',
  }).formatToParts(new Date(refMs));
  const pick = (type) => parseInt(parts.find((p) => p.type === type)?.value || '0', 10);
  const y = pick('year');
  const m = pick('month');
  return new Date(Date.UTC(y, m, 0)).getUTCDate();
}

/**
 * chargeStartMs から当月末カットオフまでの日割り金額（切り上げ）
 * Stripe の proration は秒単位のため、月末当日の数時間分も 0 にしない。
 */
export function estimateProratedAmount(monthlyPrice, chargeStartMs) {
  const price = Math.round(Number(monthlyPrice) || 0);
  if (price <= 0) return 0;

  const monthEndMs = cutoffMsForJstMonthEnd(chargeStartMs);
  const lastDayMs = lastUsageDayMsFromCutoff(monthEndMs);
  if (!lastDayMs) return price;

  const remainingMs = Math.max(0, monthEndMs - chargeStartMs);
  const daysInMonth = getDaysInJstMonth(chargeStartMs);
  if (daysInMonth <= 0) return price;

  const monthMs = daysInMonth * 86400000;
  return Math.ceil((price * remainingMs) / monthMs);
}
